export var BillingInterval;
(function (BillingInterval) {
    BillingInterval["Monthly"] = "MONTHLY";
    BillingInterval["Annually"] = "ANNUALLY";
})(BillingInterval || (BillingInterval = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["FillingForm"] = 0] = "FillingForm";
    PaymentStatus[PaymentStatus["UnexpectedError"] = 1] = "UnexpectedError";
    PaymentStatus[PaymentStatus["Success"] = 2] = "Success";
    PaymentStatus[PaymentStatus["Cancellation"] = 3] = "Cancellation";
})(PaymentStatus || (PaymentStatus = {}));
export var InvoicePeriod;
(function (InvoicePeriod) {
    InvoicePeriod["CurrentMonth"] = "CURRENT_MONTH";
    InvoicePeriod["LastMonth"] = "LAST_MONTH";
    InvoicePeriod["Last6Months"] = "LAST_6_MONTHS";
    InvoicePeriod["Last12Months"] = "LAST_12_MONTHS";
    InvoicePeriod["AllInvoices"] = "ALL_INVOICES";
})(InvoicePeriod || (InvoicePeriod = {}));
//# sourceMappingURL=payment.enum.js.map